import { DownOutlined, LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { makeStyles } from '@material-ui/core';
import { Divider, Dropdown, Layout, Menu } from 'antd';
import { useEffect, useState } from 'react';
import { trackPromise } from 'react-promise-tracker';
import { useData } from '../../../data';
import { useRouter } from '../../../routes';


const useStyles = makeStyles(theme => ({
  layout: {
    margin: 0,
    padding: 0,
  },
  menuItem: {
    padding: '20px'
  }
}))

export default function PageHeader(props) {
  const classes = useStyles();
  const router = useRouter();

  const { SubMenu } = Menu;
  const { Header } = Layout;
  const data = useData()
  const auth = data.auth()

  const [showBackButton, setShowBackButton] = useState(false);
  const [user, setUser] = useState(null);

  // load the current user
  const loadUser = () => {
    trackPromise(
      auth.getCurrentUser()
        .then(setUser)
        .catch(console.log), 'get_user'
    )
  }

  // get the currently signed in user
  useEffect(() => {
    loadUser()
  }, [])

  const menu = (
    <Menu>
      <Menu.Item key="0" onClick={() => router.push('/dashboard/profile')}>
        <UserOutlined /> Profile
      </Menu.Item>

      {props.user && props.user.is_superuser &&
        <Menu.Item key="1" onClick={() => router.push('/dashboard/admin')}>
          <UserOutlined /> Admin
        </Menu.Item>
      }

      <Menu.Divider />
      <Menu.Item key="3" onClick={() => props.logout()}>
        <LogoutOutlined /> Log Out
      </Menu.Item>
    </Menu>
  );


  const notifications = (
    <Menu>
      <Menu.Item key="0">
        <a href="#" className="notifications-link"> Glassdoor has been started successfully. Job id: 232 </a>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="2">
        <a href="#" className="notifications-link"> Glassdoor has been completed successfully. Job id: 232 </a>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="3">
        <a href="#" className="notifications-link">
          Download file for Glassdoor has been generated successfully.
        </a>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="3">
        <a href="#" style={{ textAlign: 'center' }} className="notifications-link">
          See all
        </a>
      </Menu.Item>
    </Menu>
  );

  return (
    <div className={classes.layout}>
      {/* {showBackButton && <OutlineIconButton onClick={() => router.back()}>
        <ArrowLeftOutlined style={{ fontSize: '24px' }} />
      </OutlineIconButton>} */}

      <Header className="header">
        <div className="main-logo">
          <img src="/apple-touch-icon.png" alt="logo" />
          <span>ALGS</span>
        </div>

        <div>
          {/* <Dropdown overlay={notifications} placement="bottomRight" trigger={['click']} className='notifications'>
            <a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
              <Badge size="default" count={3} offset={[0, 3]}>
                <BellOutlined className="notification-icon"/>
              </Badge>
            </a>
          </Dropdown> */}
          <Divider type="vertical" />
          <Dropdown overlay={menu} trigger={['click']}>
            <a className="ant-dropdown-link avater-link" onClick={e => e.preventDefault()}>
              {user &&
                <img className="user-avater" src={'https://ui-avatars.com/api/?background=random&size=50&name=' + user.first_name} />
              }
              {user ? user.first_name : 'Jone Doe'} <DownOutlined />
            </a>
          </Dropdown>
        </div>

      </Header>

    </div>
  );
}
